import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getListCurrency = (params) => {
    return axios.get(`${backendHost}/api/admin/currency`, {params});
};